import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { formatTwoCharacter } from "utils/common";
import { submitEntry } from "features/Entries/entrySlice";
import { SERVICE } from "constants/global";

const FormEntry = ({ item, openFn, setEntrySetting }) => {
  const dispatch = useDispatch();

  let action = "";

  // data form input sau khi render hiển thị data đã nhập trước đó
  const [object, setObject] = useState({});

  // required DATE / FLAG DATE
  const today = new Date();
  const YEAR_START = 2015;
  const YEAR_END = YEAR_START + 10;

  const { message } = useSelector((state) => state.entry);

  const Options = ({ start, end }) => {
    var array = [];
    for (let i = start; i <= end; i++) {
      array.push(
        <option className="text-center" key={i} value={formatTwoCharacter(i)}>
          {formatTwoCharacter(i)}
        </option>
      );
    }
    return array;
  };

  const OptionEntryResult = ({ entry }) => {
    if (entry?.type === "text") {
      return (
        <input
          type="text"
          defaultValue={entry.data || ""}
          className="form-control"
          id={entry.name_control}
          name={entry.name_control}
          placeholder={entry.placeholder}
          maxLength={entry.length ?? null}
          disabled={entry.readonly}
        />
      );
    } else if (entry?.type === "textarea") {
      return (
        <textarea
          className="form-control"
          rows="5"
          defaultValue={entry.data || ""}
          id={entry.name_control}
          name={entry.name_control}
          placeholder={entry.placeholder}
          maxLength={entry.length ?? null}
          disabled={entry.readonly}
        ></textarea>
      );
    } else if (entry?.type === "date") {
      const [date, setDate] = useState({
        year:
          entry.data?.split("-")[0] || today.getFullYear(),
        month:
          entry.data?.split("-")[1] ||
          formatTwoCharacter(today.getMonth() + 1),
        day:
          entry.data?.split("-")[2] ||
          formatTwoCharacter(today.getDate()),
      });

      const handleChange = (e) => {
        const { id, value } = e.target;
        setDate({ ...date, [id]: value });
      };

      return (
        <>
          <input
            type="hidden"
            name={entry.name_control}
            value={date.year + "-" + date.month + "-" + date.day}
          />
          <div className="row gx-4 gy-2 gy-md-0 row-cols-1 row-cols-md-4">
            <div className="col d-flex align-items-center">
              <select
                className="form-control signup_date_form"
                defaultValue={date.year}
                onChange={handleChange}
                id={"year"}
                disabled={entry.readonly}
              >
                <Options start={YEAR_START} end={YEAR_END} />
              </select>
              <span className="signup_date_text ms-3">年</span>
            </div>

            <div className="col d-flex align-items-center">
              <select
                className="form-control signup_date_form"
                defaultValue={date.month}
                onChange={handleChange}
                id={"month"}
                disabled={entry.readonly}
              >
                <Options start={1} end={12} />
              </select>
              <span className="signup_date_text ms-3">月</span>
            </div>

            <div className="col d-flex align-items-center">
              <select
                className="form-control signup_date_form"
                defaultValue={date.day}
                onChange={handleChange}
                id={"day"}
                disabled={entry.readonly}
              >
                <Options start={1} end={31} />
              </select>
              <span className="signup_date_text ms-3">日</span>
            </div>
          </div>
        </>
      );
    } else if (entry?.type === "select") {
      if (!entry.options) return null;
      const options = entry.options.split(",");
      return (
        <select
          className="form-control"
          name={entry.name_control}
          defaultValue={entry.data}
          disabled={entry.readonly}
        >
          <option value=""></option>
          {options.map((item, index) => (
            <option key={index} value={item}>
              {item}
            </option>
          ))}
        </select>
      );
    } else if (entry?.type === "checkbox") {
      if (!entry.options) return null;

      const checks = entry.options.split(",");
      return (
        <>
          {checks.map((item, index) => (
            <div className="d-block my-2" key={index}>
              <input
                className="form-check-input"
                type={entry.type}
                name={entry.name_control}
                id={entry.name_control + "-" + item}
                value={item}
                defaultChecked={entry.data?.includes(item)}
                disabled={entry.readonly}
              />
              <label htmlFor={entry.name_control + "-" + item} className="ms-2">
                {item}
              </label>
            </div>
          ))}
        </>
      );
    } else if (entry?.type === "radio") {
      if (!entry.options) return null;

      const checks = entry.options.split(",");
      return (
        <>
          {checks.map((item, index) => (
            <div className="d-block my-2" key={index}>
              <input
                className="form-check-input"
                name={entry.name_control}
                id={entry.name_control + "-" + item}
                type={entry.type}
                value={item}
                defaultChecked={
                  entry.data === item ? true : false
                }
                disabled={entry.readonly}
              />
              <label htmlFor={entry.name_control + "-" + item} className="ms-2">
                {item}
              </label>
            </div>
          ))}
        </>
      );
    }
  };

  const EntryResult = () => {
    return item.entryResults?.map((entry, index) => {
      return (
        <div key={index} className="my-3">
          <div
            className={`${
              entry.type !== "radio" && entry.type !== "checkbox"
                ? "form-group"
                : ""
            }${
              message?.[entry.name_control] &&
              message[entry.name_control] !== ""
                ? " has-error"
                : ""
            }`}
          >
            <div className="title-entry mb-1">{entry.label}</div>

            <OptionEntryResult key={index} entry={entry} />

            {message?.[entry.name_control] &&
              message[entry.name_control] !== "" && (
                <div className="alert alert-danger mt-2">
                  {message[entry.name_control]}
                </div>
              )}
          </div>
          <hr className="my-4" />
        </div>
      );
    });
  };

  const DateFlag = () => (
    <>
      <div
        className={`pb-3 form-group ${
          message?.[item.date_key] && message[item.date_key] !== ""
            ? "has-error"
            : ""
        }`}
      >
        <div className="title-entry mb-1">{item.date_name}</div>
        <div className="row gx-4 gy-2 gy-md-0 row-cols-1 row-cols-md-4">
          <div className="col d-flex align-items-center">
            <select
              className=" form-control signup_date_form"
              name={`${item.date_key}-y`}
              defaultValue={
                object?.[`${item.date_key}-y`] || today.getFullYear()
              }
            >
              <Options start={YEAR_START} end={YEAR_END} />
            </select>
            <span className="signup_date_text ms-3">年</span>
          </div>

          <div className="col d-flex align-items-center">
            <select
              className=" form-control signup_date_form"
              name={`${item.date_key}-m`}
              defaultValue={
                object?.[`${item.date_key}-m`] ||
                formatTwoCharacter(today.getMonth() + 1)
              }
            >
              <Options start={1} end={12} />
            </select>
            <span className="signup_date_text ms-3">月</span>
          </div>

          <div className="col d-flex align-items-center">
            <select
              className=" form-control signup_date_form"
              name={`${item.date_key}-d`}
              defaultValue={
                object?.[`${item.date_key}-d`] ||
                formatTwoCharacter(today.getDate())
              }
            >
              <Options start={1} end={31} />
            </select>
            <span className="signup_date_text ms-3">日</span>
          </div>
        </div>
        {message?.[item.date_key] && message[item.date_key] !== "" && (
          <div className="alert alert-danger mt-2">
            {message?.[item.date_key]}
          </div>
        )}
      </div>
    </>
  );

  const handleSubmit = (e) => {
    const formData = new FormData(e.target);
    const entry = {
      service: SERVICE,
      is_redirect: false,
      is_submit: false,
      is_cancel: false,
      is_rollback: false,
    };

    for (let key of formData.keys()) {
      if (!entry[key]) {
        entry[key] = formData.get(key);
      } else {
        entry[key] = formData.getAll(key);
      }
    }

    switch (action) {
      case "redirect":
        entry.is_redirect = true;
        break;
      case "rollback":
        entry.is_rollback = true;
        break;
      default:
        entry.is_submit = true;
        break;
    }

    action = "";
    if (item?.url_submit_flg === 1 && item.promotion_url && entry.is_redirect) {
      window.open(item.promotion_url, "_blank", "noreferrer");
    }
    setObject(entry);
    dispatch(submitEntry(entry));
    e.preventDefault();
  };

  const submit = (e) => {
    if (
      !(item?.url_submit_flg === 1 && item.promotion_url) ||
      action === "cancel"
    ) {
      e.preventDefault();
    }
    if (action === "cancel") {
      setEntrySetting(item);
      openFn("modal-cancel");
      action = "";
    } else {
      handleSubmit(e);
    }
  };

  if (item.step_action == 3) {
    return (
      // <div className="py-2">現在のステータス: {item.agency_approval}</div>
      <div className="my-2">
        <div>
          <label className="fw-600">ポイント判定： </label> {item.agency_approval}
        </div>
        <div>
          <label className="fw-600">付与ポイント： </label> {item.point}
        </div>
      </div>
    );
  }

  return (
    <form
      id={item.entry_id}
      onSubmit={submit}
      className="form_applicant my-3"
    >
      <input
        type="hidden"
        id="entry_id"
        name="entry_id"
        value={item?.entry_id}
      />
      <input
        type="hidden"
        id="promotion_step_id"
        name="promotion_step_id"
        value={item?.promotion_step_id}
      />

      {/* DATE FLG = 1 */}
      {/* {item && item.date_flg == 1 && <DateFlag />} */}

      {/* FOREACH ENTRIES RESULT */}
      {item.entryResults && <EntryResult />}

      <div className="mt-4">
        {item.rollback == 1 && (
          <div className="mb-3">
            <button
              onClick={() => (action = "rollback")}
              type="submit"
              className="rollback text-decoration-none"
            >
              <i className="bi bi-play-fill"></i>
              {item.back_name}
            </button>
          </div>
        )}
        <div className="d-flex justify-content-center mb-1">
        { item.next_step_flg == 1 ?
          (item.url_submit_flg == 1 && item?.promotion_active == 1) ? (
            <button
              onClick={() => (action = "redirect")}
              type="submit"
              className="btn-content-box"
            >
              {item.next_step_name}
            </button>
          ) : (
            <button type="submit" className="btn-content-box">
              {item.next_step_name}
            </button>
          )
         : null 
         }
          { item.show_cancel_flg == 1 ?
            <button
              onClick={() => (action = "cancel")}
              type="submit"
              className="btn-content-box"
            >
              {item.show_cancel_flg_name || "キャンセル"}
            </button> 
          : null }
        </div>
      </div>
    </form>
  );
};

export default FormEntry;
